export default __webpack_public_path__ + "static/media/terms.64e9d4da.svg";